<template>
    <div class="container" v-if="visibility">

        <div style="display: flex; justify-content: space-between; align-items: center;">
            <h3 style="color: #ff9b05;">{{ title }}:</h3>

            <div style="display: flex; gap: 1rem; justify-content: center; align-items: center;">
                <button class="saveBtn" id="saveBtn" @click="save">Salvar</button>
                <button class="deleteBtn" id="deleteBtn">Apagar Todos</button>
                <AppButton v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                    @close="close" :width=20 :height=20 />
            </div>
        </div>

        <!-- Added Inputs for Start Time and End Time -->
        <div class="flex gap-2 items-center">
            <div class="flex gap-1">

                <label class="text-white" for="tempo-inicial">Tempo Inicial:</label>
                <input class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40" type="text"
                    v-model="tempoInicial" placeholder="08:00" />
            </div>
            <div class="flex gap-1">

                <label class="text-white" for="tempo-final">Tempo Final:</label>
                <input class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40" type="text"
                    v-model="tempoFinal" placeholder="08:30" />
            </div>
            <AppButton :padding="'var(--padding_btn)'" :visibility="true" emitType="select" @select="definirHorario"
                :font_size="12" color='#9797EF' :left_icon="'fa-solid fa-pen-to-square'
                    " text="Definir" />
            <!-- <button class="definirBtn" @click="definirHorario">Definir</button> -->
        </div>

        <div class="task__container" id="task__container">
            <div class="task__name" id="break" style="background-color: #f7f779; display: none;">Break</div>
            <div class="task__name" id="gym" style="background-color: #f68080; display: none;">Gym</div>
            <div class="task__name" id="study" style="background-color: #faae7b; display: none;">Study</div>
            <div class="task__name" id="tv" style="background-color: #2a9d8f; display: none;">Tv</div>
            <div class="task__name" id="friends" style="background-color: #a8dadc; display: none;">Friends</div>
            <div class="task__name" id="work" style="background-color: #ff9b05;; display: none;">Work</div>
            <div class="task__name" id="deselect" style="display: none;">Deselect All</div>
        </div>

        <div class="schedule__container" id="schedule__container">
            <div class="days__container">
                <span class="corner"></span>
                <div class="day">segunda</div>
                <div class="day">terça</div>
                <div class="day">quarta</div>
                <div class="day">quinta</div>
                <div class="day">sexta</div>
                <div class="day">sabado</div>
                <div class="day">domingo</div>
                <div class="day">feriado</div>
                <div class="action_day"></div>
            </div>
            <template v-for="(time, n) in shift" :key="time">
                <div class="part__day"
                    :style="{ display: show_night_shift || time < '19:00' && time >= '08:00' ? 'flex' : 'none' }">
                    <span class="time">{{ time }}</span>
                    <div class="task" :id="`segunda_${n}`"></div>
                    <div class="task" :id="`terça_${n}`"></div>
                    <div class="task" :id="`quarta_${n}`"></div>
                    <div class="task" :id="`quinta_${n}`"></div>
                    <div class="task" :id="`sexta_${n}`"></div>
                    <div class="task" :id="`sabado_${n}`"></div>
                    <div class="task" :id="`domingo_${n}`"></div>
                    <div class="task" :id="`feriado_${n}`"></div>
                    <div class="action_task">
                        <i v-if="time == '18:30'" class="fa-solid fa-circle-chevron-down fa-xl"
                            style="color: #ff9b05; cursor: pointer; width: 20px;" @click="showNightShift"></i>
                    </div>
                </div>
            </template>
        </div>

        <div class="pop-up__container" id="pop-up__container">
            <div class="pop-up">
                <h4>Are you sure you want to delete all the tasks from your schedule?</h4>
                <div class="btn__container">
                    <div class="btn__answer" id="btn__yes">YES</div>
                    <div class="btn__answer_no" id="btn__no">NO</div>
                </div>
            </div>
        </div>

    </div>


</template>

<script>



import AppButton from '@/components/updated/button.vue'
import { watch, ref } from 'vue';
import { toast } from "vue3-toastify";
export default {
    name: 'AppSchedule',
    components: {
        AppButton
    },
    data() {
        return {
            horario_copy: [...this.horario],
            visibility: true,
            title: "Horario",
            horario_final: [],
            day_shift: Array.from({ length: 22 }, (_, i) => `${Math.floor(i / 2) + 8 < 10 ? '0' : ''}${Math.floor(i / 2) + 8}:${i % 2 === 0 ? '00' : '30'}`),

            night_shift: Array.from({ length: 27 }, (_, i) => {
                let hour = Math.floor(i / 2) + 19;
                if (hour >= 24) hour -= 24;
                return `${hour < 10 ? '0' : ''}${hour}:${i % 2 === 0 ? '00' : '30'}`;
            }),
            shift: [...Array.from({ length: 22 }, (_, i) => `${Math.floor(i / 2) + 8 < 10 ? '0' : ''}${Math.floor(i / 2) + 8}:${i % 2 === 0 ? '00' : '30'}`),
            ...Array.from({ length: 26 }, (_, i) => {
                let hour = Math.floor(i / 2) + 19;
                if (hour >= 24) hour -= 24;
                return `${hour < 10 ? '0' : ''}${hour}:${i % 2 === 0 ? '00' : '30'}`;
            })],
            bi_array: Array.from({ length: 49 }, () => Array(7).fill(null)),

            show_night_shift: false,

            tempoInicial: '',
            tempoFinal: '',
        }
    },

    components: {
        AppButton
    },
    props: {
        show: Boolean,
        horario: Array
    },


    mounted() {

        const breakTask = document.getElementById('break');
        const gymTask = document.getElementById('gym');
        const studyTask = document.getElementById('study');
        const tvTask = document.getElementById('tv');
        const friendsTask = document.getElementById('friends');
        const workTask = document.getElementById('work');
        const deselectBtn = document.getElementById('deselect');
        const taskContainer = document.getElementById('task__container');
        const scheduleContainer = document.getElementById('schedule__container');
        const resetBtn = document.getElementById('deleteBtn');
        const popUp = document.getElementById('pop-up__container');
        const noBtn = document.getElementById('btn__no');
        const yesBtn = document.getElementById('btn__yes');


        let horario_copy2 = ref([...this.horario_copy]);
        //let utilizador_id=this.horario_copy[0].utilizador_id;


        let inicioDay = "";
        let fimDay = "";
        let inicio = {}; // Object to store the start hour for each day
        let fim = {};

        let horario_final = ref([]);;
        watch(horario_final.value, (newVal, oldVal) => {
            console.log('horario_final changed:', newVal);
            this.horario_final = [...newVal];
            // You can add more code here to react to changes in horario_final
        });



        watch(this.horario_copy, (newVal) => {
            horario_copy2.value = [...newVal];
            horario_final = [];
            inicio = {}; // Object to store the start hour for each day
            fim = {};
            inicioDay = "";
            fimDay = "";
            updateSchedule();
        });
        let selectedColor, active, taskColor, icon;
        //let days = ['segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

        //Event Listeners
        taskContainer.addEventListener('click', selectTask);
        scheduleContainer.addEventListener('click', setColors);
        deselectBtn.addEventListener('click', resetTasks);
        resetBtn.addEventListener('click', openPopup);
        noBtn.addEventListener('click', closePopup);
        yesBtn.addEventListener('click', deleteTasks);


        let event = { target: workTask };


        // Call selectTask with the event object
        selectTask(event);

        // Tasks click  (3)
        function selectTask(e) {
            resetTasks()

            taskColor = e.target.style.backgroundColor;

            switch (e.target.id) {
                case 'break':
                    activeTask(breakTask, taskColor);
                    icon = '<i class="fas fa-couch"></i>';
                    break
                case 'gym':
                    activeTask(gymTask, taskColor);
                    icon = '<i class="fas fa-dumbbell"></i>';
                    break
                case 'study':
                    activeTask(studyTask, taskColor);
                    icon = '<i class="fas fa-book"></i>';
                    break
                case 'tv':
                    activeTask(tvTask, taskColor);
                    icon = '<i class="fas fa-tv"></i>';
                    break
                case 'friends':
                    activeTask(friendsTask, taskColor);
                    icon = '<i class="fas fa-users"></i>';
                    break
                case 'work':
                    activeTask(workTask, taskColor);
                    // icon = '<i class="fas fa-briefcase"></i>';
                    icon = '';
                    break
            }

        }

        function updateInicioFimOnAdd(task) {
            const currentHour = task.closest('.part__day').querySelector('.time').textContent;
            const currentDay = task.id.split('_')[0]; // Extract the day from the task ID

            if (!inicio[currentDay] || currentHour < inicio[currentDay]) {
                inicio[currentDay] = currentHour;
            }
            if (!fim[currentDay] || currentHour > fim[currentDay]) {
                fim[currentDay] = currentHour;
            }

            console.log("Updated inicio:", inicio);
            console.log("Updated fim:", fim);
        }

        // Function to update inicio and fim when a task is deleted
        function updateInicioFimOnDelete(task) {
            const currentDay = task.id.split('_')[0]; // Extract the day from the task ID
            const tasksInDay = document.querySelectorAll(`.task[id^="${currentDay}"]`);

            let earliestHour = null;
            let latestHour = null;

            tasksInDay.forEach(task => {
                if (task.style.backgroundColor === selectedColor) {
                    let currentHour = task.closest('.part__day').querySelector('.time').textContent;
                    const currentHourNumber = parseInt(currentHour.split(':')[0]);

                    // If the current hour is less than 8, add 24 to it
                    if (currentHourNumber < 8) {
                        currentHour = (currentHourNumber + 24) + currentHour.slice(2);
                    }

                    if (!earliestHour || currentHour < earliestHour) {
                        earliestHour = currentHour;
                    }
                    if (!latestHour || currentHour > latestHour) {
                        latestHour = currentHour;
                    }
                }
            });

            // Only update inicio and fim for the current day
            if (earliestHour !== null) {
                inicio[currentDay] = earliestHour;
            } else {
                delete inicio[currentDay];
            }

            if (latestHour !== null) {
                fim[currentDay] = latestHour;
            } else {
                delete fim[currentDay];
            }

            // Update horario_final
            if (inicio[currentDay] && fim[currentDay]) {
                const item = horario_final.value.find(item => item.dia === currentDay);
                if (item) {
                    item.inicio = inicio[currentDay];
                    item.fim = fim[currentDay];
                    item.action = "updated";
                } else {
                    horario_final.value.push({
                        id: 0,
                        dia: currentDay,
                        inicio: inicio[currentDay],
                        fim: fim[currentDay],
                        nome: "sem nome",
                        status: "novo",
                        utilizador_id: 0,
                        action: "added"
                    });
                }
            } else {
                horario_final.value.map((item, index) => {
                    if (item.status == 'ativo' && item.dia === currentDay) {
                        item.action = "deleted";
                    }
                    else if (item.status == 'novo' && item.dia === currentDay) {
                        horario_final.value.splice(index, 1);
                    }
                });
            }

            horario_copy2.value = horario_final.value;

            console.log("Updated inicio:", inicio);
            console.log("Updated fim:", fim);
            console.log("horario_final:", horario_final.value);
        }



        // Set colors for schedule
        function setColors(e) {
            if (e.target.classList.contains('task') && active === true) {
                let currentHour = e.target.closest('.part__day').querySelector('.time').textContent;
                let currentDay = e.target.id.split('_')[0]; // Extract the day from the task ID

                if (e.target.style.backgroundColor === selectedColor) {
                    e.target.style.backgroundColor = '';
                    e.target.innerHTML = '';

                    // Update inicio and fim when a task is deleted
                    updateInicioFimOnDelete(e.target);


                    // Update horario_copy2 when a task is deleted
                    //updateHorarioCopy2();
                } else {
                    e.target.style.backgroundColor = selectedColor;
                    e.target.innerHTML = icon;

                    // Update inicio and fim when a task is added
                    updateInicioFimOnDelete(e.target);


                    // Update horario_copy2 when a task is added
                    //updateHorarioCopy2();
                }



            }
        }

        // Function to update horario_copy2 when a task is added or removed
        function updateHorarioCopy2() {
            //console.log("horario_copy2:", horario_copy2.value);

            // Update inicio and fim times
            for (let day in inicio) {
                let item = horario_copy2.value.find(item => item.dia === day);
                if (item) {
                    item.inicio = inicio[day];
                    item.fim = fim[day];
                } else {
                    // Add new day
                    horario_copy2.value.push({
                        id: 0,
                        dia: day,
                        inicio: inicio[day],
                        fim: fim[day],
                        status: "novo"
                    });
                }
            }

            //console.log("Updated horario_copy2:", horario_copy2.value);
        }


        function activeTask(task, color) {
            task.classList.toggle('selected');

            if (task.classList.contains('selected')) {
                active = true;
                selectedColor = color;
                return selectedColor;
            } else {
                active = false;
            }
        }

        // Reset tasks (2)
        function resetTasks() {
            const allTasks = document.querySelectorAll('.task__name');

            allTasks.forEach((item) => {
                item.className = 'task__name';
            })
        }

        // Delete tasks
        function deleteTasks() {
            const tasks = document.querySelectorAll('.task');

            tasks.forEach((item) => {
                item.innerHTML = '';
                item.style.backgroundColor = '#a5a5eb8c';
            })
            horario_final.value.map((item, index) => {
                item.action = "deleted";
            });
            horario_copy2.value = [];
            inicio = {};
            fim = {};

            closePopup();
        }

        // Open Pop-up
        function openPopup() {
            popUp.style.display = 'flex';
        }

        // Close Pop-up
        function closePopup() {
            popUp.style.display = 'none';
        }

        function updateSchedule() {
            console.log("horario_copy:", horario_copy2.value)
            // Reset all task colors
            const tasks = document.querySelectorAll('.task');
            tasks.forEach(task => {
                task.style.backgroundColor = '';
                task.innerHTML = '';
            });

            // Loop through horario_copy and update schedule
            horario_copy2.value.forEach(item => {
                let startHour = parseInt(item.inicio.split(':')[0]);
                let endHour = parseInt(item.fim.split(':')[0]);
                const startMinute = parseInt(item.inicio.split(':')[1]);
                const endMinute = parseInt(item.fim.split(':')[1]);

                // If the end hour is less than the start hour, add 24 to it
                if (endHour < startHour) {
                    endHour += 24;
                }

                const startIndex = (startHour - 8) * 2 + (startMinute === 30 ? 1 : 0);
                const endIndex = (endHour - 8) * 2 + (endMinute === 30 ? 1 : 0);

                // Add day and inicio to the inicio object
                inicio[item.dia] = item.inicio;
                fim[item.dia] = item.fim;

                horario_final.value.push({
                    id: item.id,
                    nome: item.nome,
                    dia: item.dia,
                    inicio: item.inicio,
                    fim: item.fim,
                    status: item.status,
                    utilizador_id: item.utilizador_id
                });

                for (let i = startIndex; i <= endIndex; i++) { // Change condition to include endIndex
                    const taskId = `${item.dia}_${i}`;
                    const taskElement = document.getElementById(taskId);
                    if (taskElement) {
                        taskElement.style.backgroundColor = selectedColor;
                        taskElement.innerHTML = icon;
                    }
                }
            });
            console.log("inicio:", inicio)
            console.log("fim:", fim)
            console.log("horario_final:", horario_final.value)
        }

        function updateColor() {
            // console.log("horario_copy:",horario_copy2.value)
            // Reset all task colors
            const tasks = document.querySelectorAll('.task');


            // Loop through horario_copy and update schedule
            horario_final.value.filter(item => item.action != 'deleted').forEach(item => {
                let startHour = parseInt(item.inicio.split(':')[0]);
                let endHour = parseInt(item.fim.split(':')[0]);
                const startMinute = parseInt(item.inicio.split(':')[1]);
                const endMinute = parseInt(item.fim.split(':')[1]);

                // If the end hour is less than the start hour, add 24 to it
                if (endHour < startHour) {
                    endHour += 24;
                }

                const startIndex = (startHour - 8) * 2 + (startMinute === 30 ? 1 : 0);
                const endIndex = (endHour - 8) * 2 + (endMinute === 30 ? 1 : 0);

                // Add day and inicio to the inicio object
                inicio[item.dia] = item.inicio;
                fim[item.dia] = item.fim;


                for (let i = startIndex; i <= endIndex; i++) { // Change condition to include endIndex
                    const taskId = `${item.dia}_${i}`;
                    const taskElement = document.getElementById(taskId);
                    if (taskElement) {
                        taskElement.style.backgroundColor = selectedColor;
                        taskElement.innerHTML = icon;
                    }
                }
            });

        }


        function save() {
            console.log("horario_final:", horario_final.value);

        }
        updateSchedule();

    },
    methods: {
        close() {
            this.$emit('close')
        },

        save() {
            console.log("horario_final:", this.horario_final)
            this.$emit('save', this.horario_final)

        },
        updateHorario() {
            console.log("horario is:", this.horario)
            this.horario_copy = [...this.horario];
        },


        showNightShift() {

            this.show_night_shift = !this.show_night_shift
            console.log("show_night_shift:", this.show_night_shift)
        },

        timeToMinutes(time) {
            const [hours, minutes] = time.split(':').map(Number);
            let minutesPastMidnight = hours * 60 + minutes;

            // If the time is between 00:00 and 08:00, add 24 hours to it
            if (hours < 8) {
                minutesPastMidnight += 24 * 60;
            }

            return minutesPastMidnight;
        },

        definirHorario() {
        if (!this.tempoInicial || !this.tempoFinal) {
            toast("Tempo inicial ou final Vazio!", {
                theme: "auto",
                type: "warning",
                position: "top-center",
                autoClose: 1000,
            });
            return;
        }

        // Validate time format for both initial and final times
        if (!this.validateTime('tempoInicial') || !this.validateTime('tempoFinal')) {
            return;
        }

        const start = this.TimeToMinutes(this.tempoInicial);
        const end = this.TimeToMinutes(this.tempoFinal);

        // Adjust end time if it is less than start time (crossing midnight)
        let adjustedEnd = end;
        if (end <= start) {
            adjustedEnd = end + 24 * 60; // Add 24 hours in minutes
        }

        const duration = adjustedEnd - start;

        // Validate that duration is positive
        if (duration <= 0) {
            toast("O tempo final deve ser depois do tempo inicial!", {
                theme: "auto",
                type: "warning",
                position: "top-center",
                autoClose: 1000,
            });
            return;
        }

        // Define the working days and days in the schedule
        const workingDays = ['segunda', 'terça', 'quarta', 'quinta', 'sexta'];
        const days = ['segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo', 'feriado'];

        // Clear colors and reset task elements for all days
        days.forEach(day => {
            for (let i = 0; i < 49; i++) { // 49 slots from 08:00 to 07:30
                const taskId = `${day}_${i}`;
                const taskElement = document.getElementById(taskId);
                if (taskElement) {
                    taskElement.style.backgroundColor = '';  // Reset color
                    taskElement.innerHTML = '';  // Clear content like icons
                }
            }
        });

        // Set new schedule for working days from tempoInicial to tempoFinal
        workingDays.forEach(day => {
            const startIndex = this.calculateIndex(this.tempoInicial); // Index for start time
            const endIndex = this.calculateIndex(this.tempoFinal);     // Index for end time

            if (adjustedEnd - start >= 24 * 60) {
                // If the duration is 24 hours or more, fill all time slots
                for (let i = 0; i < 49; i++) {
                    const taskId = `${day}_${i}`;
                    const taskElement = document.getElementById(taskId);
                    if (taskElement) {
                        taskElement.style.backgroundColor = '#ff9b05';  // Set task color
                    }
                }
            } else if (endIndex < startIndex) {
                // If the schedule crosses midnight, handle two ranges
                for (let i = startIndex; i < 48; i++) {
                    const taskId = `${day}_${i}`;
                    const taskElement = document.getElementById(taskId);
                    if (taskElement) {
                        taskElement.style.backgroundColor = '#ff9b05';  // Set task color
                    }
                }
                for (let i = 0; i <= endIndex; i++) {
                    const taskId = `${day}_${i}`;
                    const taskElement = document.getElementById(taskId);
                    if (taskElement) {
                        taskElement.style.backgroundColor = '#ff9b05';  // Set task color
                    }
                }
            } else {
                // For schedules without crossing midnight
                for (let i = startIndex; i <= endIndex; i++) {
                    const taskId = `${day}_${i}`;
                    const taskElement = document.getElementById(taskId);
                    if (taskElement) {
                        taskElement.style.backgroundColor = '#ff9b05';  // Set task color
                    }
                }
            }

            // Check if there's an existing schedule for the day
            const existingSchedule = this.horario_final.find(item => item.dia === day && item.status === 'ativo');

            if (existingSchedule) {
                // If the schedule exists, update it
                existingSchedule.inicio = this.tempoInicial;
                existingSchedule.fim = this.tempoFinal;
                existingSchedule.action = 'updated';
            } else {
                // If no schedule exists, add a new one
                this.horario_final.push({
                    id: 0,  // Placeholder ID, replace if necessary
                    dia: day,
                    inicio: this.tempoInicial,
                    fim: this.tempoFinal,
                    nome: "sem nome",  // Placeholder, update if necessary
                    status: 'novo',
                    utilizador_id: 0,  // Placeholder user ID, update if necessary
                    action: 'added'
                });
            }
        });

        // Mark non-working days (Saturday, Sunday, Holiday) as deleted in horario_final
        this.horario_final = this.horario_final.map(item => {
            if (['sabado', 'domingo', 'feriado'].includes(item.dia)) {
                return { ...item, action: 'deleted' };
            }
            return item;
        });

        // Log the updated horario_final for debugging
        console.log("horario_final:", this.horario_final);
    },

    // Helper function to convert time to index
    calculateIndex(time) {
        const minutesPastMidnight = this.TimeToMinutes(time);

        // Normalize time to start at 08:00, adjusting for night hours
        if (minutesPastMidnight >= 480) {  // 08:00 is 480 minutes past midnight
            return (minutesPastMidnight - 480) / 30;  // Calculate index for daytime
        } else {
            return (minutesPastMidnight + (24 * 60) - 480) / 30;  // Calculate index for night hours
        }
    },

    TimeToMinutes(time) {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    },

    validateTime(timeField) {
        const timeValue = this[timeField];
        const regex = /^(0[8-9]|1[0-9]|2[0-3]):(00|30)$|^(0[0-7]):(00|30)$/;

        if (!regex.test(timeValue)) {
            toast("Por favor insira o tempo no formato correto: '08:00' ou '08:30' até '07:30' do dia seguinte.", {
                theme: "auto",
                type: "warning",
                position: "top-center",
                autoClose: 1000,
            });
            this[timeField] = '';
            return false;
        }
        return true;
    },


        // .


    },

    watch: {
        horario: {
            handler() {

                this.updateHorario();
                //this.updateSchedule();
                //this.isEmptyContactField()
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>



<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400&display=swap');

.container {
    /* width: 57vw; */
    width: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 10px;
    background-color: rgba(93, 93, 152, 0.55);
}


/* TASKS CONTAINER */
.task__container {
    display: flex;
    /* margin-bottom: 3rem; */
    /* background-color: brown; */
    padding: 10px;
}

.task__container .task__name {
    padding: 10px;
    margin: 0 10px;
    border-radius: 5px;
    cursor: pointer;
}

.task__name.selected {
    box-shadow: 0px 0px 0px 2px black inset;
}

#deselect {
    background-color: #1d3557;
    color: white;
}


/* SCHEDULE DESIGN */
.schedule__container {
    /* background:linear-gradient(#ebf4f5, #b5c6e0); */
    background-color: rgba(93, 93, 152, 0.55);
    width: auto;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-radius: 10px;
}

.days__container {
    display: flex;
}

.corner {
    width: 41px;
    height: 70px;
    margin: 2px;
}

.day {
    width: 100px;

    border: solid 1px white;
    color: #ff9b05;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px;
}

.action_day {
    width: 50px;
    /* border: solid 1px white; */
    color: #ff9b05;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px;

}

.part__day {
    display: flex;
}

.time {
    min-width: 35px;
    height: 20px;
    font-size: 12px;
    color: white;
    background-color: #103783;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px;
}

.task {
    background-color: rgba(165, 165, 235, 0.55);
    height: 20px;
    width: 100px;
    margin: 2px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
}

.action_task {

    height: 20px;
    width: 50px;
    margin: 2px;
    cursor: pointer;
    display: flex;
    /* justify-content: center; */
    align-items: center;

}

/* Pop up */
.pop-up__container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
}

.pop-up {
    color: white;
    width: 300px;
    height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(93, 93, 152);
    padding: 15px;
    text-align: center;
    border-radius: 5px;
}

.btn__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.btn__answer {
    margin: 0 20px;
    background-color: rgb(188, 1, 1);
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
}

.btn__answer_no {
    margin: 0 20px;
    background-color: rgb(0, 103, 206);
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
}

.title_close {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4rem;
}

.saveBtn {
    padding: 10px 25px;

    background-color: rgb(0, 102, 152);
    color: white;
    border-radius: 5px;
    cursor: pointer;
    /* text-transform: uppercase; */
    outline: none;
}

.deleteBtn {
    padding: 10px 25px;
    color: white;
    background-color: rgb(255, 0, 0);

    border-radius: 5px;
    cursor: pointer;
    /* text-transform: uppercase; */
    outline: none;
}
</style>